import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { Actions } from '../../actions';
import { ContentContainer } from '../../components/ContentContainer';
import { GenericToolbar } from '../../components/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { Selectors } from '../../selectors';
import { SiteProfile } from '../../types';
import { EditSite } from './EditSite';

export const EditSiteProfile: React.FC<{ updatedSiteData: Function; data: SiteProfile | null }> = (
    props
): JSX.Element => {
    const history = useHistory();
    const currentAppRoute = useCurrentAppRoute();
    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const siteState = useSelector(Selectors.Site.site);
    const siteName = props.data ? props.data.name : '';
    const updatedSiteData = (updatedData: SiteProfile): void => {
        props.updatedSiteData(updatedData);
    };

    const navigateToSiteProfile = (): void => {
        if (currentAppRoute.type === 'EditSite')
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
    };

    useEffect(() => {
        if (!siteState.loading && siteState.success) {
            addToast('Site updated successfully.');
            dispatch(Actions.Site.SiteRegistrationReset());
            navigateToSiteProfile();
        }
    }, [siteState.loading, siteState.success]); //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <GenericToolbar
                title="Edit Site"
                subtitle={siteName}
                showBackButton
                backButtonOnClick={(): void => {
                    navigateToSiteProfile();
                }}
            />
            {'siteId' in currentAppRoute && props.data && (
                <ContentContainer>
                    <EditSite
                        siteProfileData={props.data}
                        cancelAction={navigateToSiteProfile}
                        updatedSiteData={updatedSiteData}
                    ></EditSite>
                </ContentContainer>
            )}
        </>
    );
};
